import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { XIcon } from 'lucide-react';
interface FeedbackModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function FeedbackModal({
  isOpen,
  onClose
}: FeedbackModalProps) {
  const {
    t
  } = useTranslation('analytics');
  const [feedback, setFeedback] = useState('');
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  const handleSubmit = () => {
    // Handle feedback submission
    console.log('Feedback submitted:', feedback);
    setFeedback('');
    onClose();
  };
  return <>
      {/* Overlay */}
      <div className="fixed inset-0 bg-black bg-opacity-30 z-50 transition-opacity" onClick={onClose} data-id="element-1876" data-mp="bqx5979numz" />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-start justify-center pt-32 pointer-events-none" data-id="element-1877" data-mp="3tkddj3kign20">
        <div role="dialog" aria-modal="true" aria-labelledby="feedback-modal-title" className="bg-white rounded-lg shadow-2xl w-full max-w-2xl pointer-events-auto" onClick={e => e.stopPropagation()} data-id="element-1878" data-mp="3olitjyat4sgb">
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200" data-id="element-1879" data-mp="g5gzrqgfy9nj">
            <h2 id="feedback-modal-title" className="text-lg font-semibold text-gray-900" data-id="element-1880" data-mp="g7a5n3j8cpuh">
              {t('components.FeedbackModal.share_feedback')}
            </h2>
            <button onClick={onClose} aria-label={t('components.AddChartModal.cancel')} className="p-1 hover:bg-gray-100 rounded transition-colors" data-id="element-1881" data-mp="l4tlg7vktaoj">
              <XIcon size={20} className="text-gray-500" aria-hidden="true" data-id="element-1882" data-mp="2mw6pkuppzejj" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6" data-id="element-1883" data-mp="3cldpwoeoevs8">
            <label htmlFor="feedback-textarea" className="sr-only" data-id="element-1884" data-mp="3cmf431qznye6">
              {t('components.FeedbackModal.share_feedback')}
            </label>
            <textarea id="feedback-textarea" value={feedback} onChange={e => setFeedback(e.target.value)} placeholder={t('components.FeedbackModal.attrs.let_us_know_what_you_think')} className="w-full h-48 px-4 py-3 text-base text-gray-900 placeholder-gray-400 border-2 border-blue-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none" data-id="element-1885" data-mp="3ljpg4pbmrrk5" />

            <div className="mt-4 flex items-center justify-between" data-id="element-1886" data-mp="d3w1kg0v0q5q">
              <p className="text-sm text-gray-600" data-id="element-1887" data-mp="i4k0dnvbybai">
                {t('components.FeedbackModal.have_a_specific_issue')}{' '}
                <a href="#" className="text-blue-600 hover:underline" data-id="element-1888" data-mp="n46a3nby99ek">
                  {t('components.FeedbackModal.contact_support')}
                </a>{' '}
                {t('components.FeedbackModal.or')}{' '}
                <a href="#" className="text-blue-600 hover:underline" data-id="element-1889" data-mp="22khu6i8qmop4">
                  {t('components.FeedbackModal.read_our_docs')}
                </a>
                .
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-200" data-id="element-1890" data-mp="2qbdqnso5282p">
            <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-1891" data-mp="2lcu0fg2iia4j">
              {t('components.AddChartModal.cancel')}
            </button>
            <button onClick={handleSubmit} className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors" data-id="element-1892" data-mp="3924wik8x3gcc">
              {t('components.FeedbackModal.send_feedback')}
            </button>
          </div>
        </div>
      </div>
    </>;
}